import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import cleanouts from '../../json/property-cleanouts-data.json'

const cleanoutsServiceData = {
  name: 'Property Cleanout Services',
  description:
    'Nationwide property cleanout service for homes, offices, and estates — furniture, appliances, electronics, and general clutter cleared out in a single visit by a crew that does all the lifting, with a diversion report on completion.',
  serviceType: 'Property Cleanout',
  url: 'https://getdimension.com/property-cleanouts',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Office Cleanout' },
    { name: 'Estate Cleanout' },
    { name: 'Garage Cleanout' },
    { name: 'Basement and Attic Cleanout' },
    { name: 'Whole-Home Cleanout' },
  ],
}

const cleanoutsFAQData = {
  questions: cleanouts.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function PropertyCleanouts() {
  return (
    <>
      <Head>
        <title>Property Cleanout Services Nationwide | Dimension</title>
        <meta
          name="description"
          content="Property cleanout services for homes, offices, and estates. Garage, basement, and whole-home clear-outs nationwide — we do the lifting, hauling, and recycling."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/property-cleanouts" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={cleanoutsServiceData} />
        <SchemaMarkup type="FAQPage" data={cleanoutsFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={cleanouts.pitch.heading}
          material={cleanouts.pitch.material}
          pitchText={cleanouts.pitch.pitchText}
          ctaLink={cleanouts.pitch.ctaLink}
          ctaText={cleanouts.pitch.ctaText}
          ctaHeading={cleanouts.pitch.ctaHeading}
          ctaSubtext={cleanouts.pitch.ctaSubtext}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...cleanouts.solutions} />
        <FeatureList {...cleanouts.benefits} />
        <CaseStudy {...cleanouts.caseStudy} />
        <Approach {...cleanouts.approach} />
        <FAQ {...cleanouts.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Commercial Office Cleanout',
              href: '/commercial-office-cleanout',
              description:
                'Lease expirations, renovations, closures, and downsizes — desks, cubicles, and equipment cleared on your deadline.',
            },
            {
              label: 'Residential Cleanout',
              href: '/residential-cleanout',
              description:
                'Whole homes, single rooms, garages, and move-outs, cleared by a crew that does all the lifting.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'When it is one item rather than a whole property — a couch, a fridge, a single load.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'The do-it-yourself alternative for a long cleanout: a container on site that you fill at your own pace.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default PropertyCleanouts
